module.exports = __webpack_public_path__ + "img/circle-z.2936db88.svg";